import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvcHighlightGroupComponent } from './svc-highlight-group.component';
import { MatIconModule } from '@angular/material/icon';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';

@NgModule({
  declarations: [
    SvcHighlightGroupComponent
  ],
	imports: [
		CommonModule,
		MatIconModule,
		LibSharedCommonModule,
	],
  exports: [
    SvcHighlightGroupComponent
  ]
})
export class SvcHighlightGroupModule { }
